var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPlusCircle = function SvgIconPlusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.998 2.547a8.44 8.44 0 0 1 8.451 8.451A8.44 8.44 0 0 1 11 19.45 8.44 8.44 0 0 1 2.546 11a8.44 8.44 0 0 1 8.451-8.452Z",
    stroke: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 6,
    width: 1.5,
    height: 10,
    rx: 0.75,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 10.25,
    width: 1.5,
    height: 10,
    rx: 0.75,
    transform: "rotate(90 16.25 10.25)",
    fill: "currentColor"
  })));
};
export default SvgIconPlusCircle;